import { CssTextField } from "./CommonStyles";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import ClearIcon from "@mui/icons-material/Clear";

function SamplingAndPackagingField({
  samplingAndPackagingCode,
  setSamplingAndPackagingCode,
  setSamplingAndPackagingCodeChild,
  handleTextFieldClick,
  handleClearInput,
  isPopupOpen,
  SamplingAndPackaging,
  handleClosePopup,
  handleSavePopup,
}) {
  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      <CssTextField
        fullWidth
        id="SamplingAndPackaging"
        label={
          <span style={{ fontSize: 12 }}>Sampling and packaging Code</span>
        }
        rows={1}
        onChange={(e) => {
          setSamplingAndPackagingCode(e.target.value);
          setSamplingAndPackagingCodeChild(e.target.value);
        }}
        value={samplingAndPackagingCode}
        variant="standard"
        sx={{ marginLeft: 0, width: "100%" }}
        disabled
      />
      <IconButton onClick={handleTextFieldClick}>
        <EditIcon />
      </IconButton>
      {samplingAndPackagingCode && (
        <IconButton onClick={handleClearInput}>
          <ClearIcon />
        </IconButton>
      )}
      {isPopupOpen && (
        <SamplingAndPackaging
          onClose={handleClosePopup}
          onSave={handleSavePopup}
          initialValues={samplingAndPackagingCode}
        />
      )}
    </div>
  );
}

export default SamplingAndPackagingField;
